import { apiConstants } from "@data/constants/apiConstants"
import { schoolsService } from "@data/services/schoolsService"
import { subscriptionService } from "@data/services/subscriptionService"
import { authConstants } from "@data/constants/authConstants"
import { authService } from "@data/services/authService"
import { backOfficeService } from "@data/services/backOfficeService"
import { pedagogicalObjectivesService } from "@data/services/pedagogicalObjectivesService"
import { tutorsService } from "@data/services/tutorsService"

// ** Initial State
const initialState = {
    list: [],
    usersList: [],
}

export function tutors(state = initialState, action) {
    switch (action.type) {
        case authConstants.LOGOUT_401:
        case authConstants.RESET_AUTH_STATE:
        case authService.logout.name + apiConstants._SUCCESS:
        case authService.revokeSanctumToken.name + apiConstants._SUCCESS:
        case authService.deleteAccount.name + apiConstants._SUCCESS:
            return initialState

        case subscriptionService.updatePrioritizedSchoolSubjects.name +
            apiConstants._SUCCESS:
        case backOfficeService.getUserBackoffice.name + apiConstants._SUCCESS:
        case backOfficeService.postNewTrialLiveSessionChoiceBackoffice.name +
            apiConstants._SUCCESS:
        case tutorsService.acceptTrials.name + apiConstants._SUCCESS:
        return {
                ...state,
                usersList:
                    state.usersList?.length === 0
                        ? [action.data]
                        : state.usersList?.find(
                                (user) => user?.id === action.data?.id
                            )
                          ? state.usersList?.map((user) =>
                                user?.id === action.data?.id
                                    ? action.data
                                    : user
                            )
                          : [...state.usersList, action.data],
            }

        case schoolsService.searchUser.name + apiConstants._SUCCESS:
            let usersList = []
            //console.log("meta", action.data)
            if (action.data?.meta?.current_page === 1) {
                // refresh
                usersList = action.data?.users
            } else {
                // concat
                usersList = state.usersList.concat(action.data?.users)
            }
            return {
                ...state,
                usersList: usersList,
            }
        case backOfficeService.putStudentAccount.name + apiConstants._SUCCESS:
            //console.log(action.data)
            const updateStudentIfFoundInStore = (a) => {
                return action.data?.id === a?.id ? action.data : a
            }
            return {
                ...state,
                usersList: state.usersList?.map(updateStudentIfFoundInStore),
            }
        case backOfficeService.putTutorAccount.name + apiConstants._SUCCESS:
            const updateTutorIfFoundInStore = (a) => {
                return action.data?.id === a?.id ? action.data : a
            }
            return {
                ...state,
                usersList: state.usersList?.map(updateTutorIfFoundInStore),
            }

        case backOfficeService.updateTutorSlots.name + apiConstants._SUCCESS:
            return {
                ...state,
                usersList: state.usersList?.map((user) => {
                    return user.id === action.data?.id ? action.data : user
                }),
            }
        case backOfficeService.newStudent.name + apiConstants._SUCCESS:
            return {
                ...state,
                usersList: [...state.usersList, action?.data],
            }
        // Pedagogical objectives actions - return full user resource
        case pedagogicalObjectivesService.createPedagogicalObjective.name +
            apiConstants._SUCCESS:
        case pedagogicalObjectivesService.updatePedagogicalObjective.name +
            apiConstants._SUCCESS:
        case pedagogicalObjectivesService.deletePedagogicalObjective.name +
            apiConstants._SUCCESS:
        case pedagogicalObjectivesService.updatePedagogicalObjectiveStatus
            .name + apiConstants._SUCCESS:
        case pedagogicalObjectivesService.updateObjectiveLiveSessions.name +
            apiConstants._SUCCESS:
        case pedagogicalObjectivesService.updateObjectivesHourAllocation.name +
            apiConstants._SUCCESS:
            return {
                ...state,
                usersList: state.usersList?.map((user) => {
                    if (user?.id === action?.data?.id) {
                        return action?.data
                    }
                    return user
                }),
            }

        default:
            return state
    }
}

export default tutors
